// First Created - 27 Apr 2026
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const organizationBUsAdapter = createEntityAdapter({})

const initialState = organizationBUsAdapter.getInitialState()

export const organizationBUsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOrganizationBUs: builder.query({
            query: () => ({
                url: '/organizationBUs/getOrganizationBUs',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedOrganizationBUs = responseData.map(organizationBU => {
                    organizationBU.id = organizationBU._id
                    return organizationBU
                })
                return organizationBUsAdapter.setAll(initialState, loadedOrganizationBUs)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'OrganizationBU', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'OrganizationBU', id}))
                    ]
                } else {
                    return [ { type: 'OrganizationBU', id: 'LIST'}]
                }
            },
        }),
        createNewOrganizationBU: builder.mutation({
            query: initialOrganizationBU => ({
                url: '/organizationBUs/createNewOrganizationBU',
                method: 'POST',
                body: {...initialOrganizationBU,}
            }),
            invalidatesTags: [
                { type: 'OrganizationBU', id: "LIST" }
            ] 
        }),
        updateOrganizationBU: builder.mutation({
            query: initialOrganizationBU => ({
                url: '/organizationBUs/updateOrganizationBU',
                method: 'PATCH',
                body: {...initialOrganizationBU,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'OrganizationBU', id: arg.id },
                { type: 'OrganizationBU', id: 'LIST' }
            ],
        }),
        deleteOrganizationBU: builder.mutation({
            query: ({ id, deleteMode = "soft" }) => ({
                url: '/organizationBUs/deleteOrganizationBU',
                method: 'DELETE',
                body: { id, deleteMode }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OrganizationBU', id: arg.id },
                { type: 'OrganizationBU', id: 'LIST' }
            ]
        }),
        // deleteOrganizationBU: builder.mutation({
        //     query: ({id}) => ({
        //         url: '/organizationBUs/deleteOrganizationBU',
        //         method: 'DELETE',
        //         body: {id}
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'OrganizationBU', id: arg.id}
        //     ]
        // }),
    }),
})

export const {
    useGetOrganizationBUsQuery,
    useCreateNewOrganizationBUMutation,
    useUpdateOrganizationBUMutation,
    useDeleteOrganizationBUMutation,
} = organizationBUsApiSlice

// returns the query result object
export const selectOrganizationBUResult = organizationBUsApiSlice.endpoints.getOrganizationBUs.select()

// create memoized selector
const selectOrganizationBUsData = createSelector(
    selectOrganizationBUResult,
    organizationBUResult => organizationBUResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllOrganizationBUs,
    selectById: selectOrganizationBUById,
    selectIds: selectOrganizationBUIds,
} = organizationBUsAdapter.getSelectors(state => selectOrganizationBUsData(state) ?? initialState)